export default __webpack_public_path__ + "static/media/linkedin.ad9d6aa3.svg";